import * as React from "react";
const SvgFiRrLayers = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-layers_svg__a)">
      <path d="M22.486 10.975 12 17.267 1.515 10.975A1 1 0 0 0 .486 12.69l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 1 0-1.028-1.715z" />
      <path d="M22.486 15.543 12 21.833l-10.486-6.29a.999.999 0 1 0-1.029 1.715l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 0 0-1.028-1.715zM12 14.773c-.54 0-1.069-.147-1.531-.425L.485 8.358a1 1 0 0 1 0-1.715l9.984-5.99a2.97 2.97 0 0 1 3.062 0l9.984 5.99a1 1 0 0 1 0 1.714l-9.984 5.991a3 3 0 0 1-1.531.425M2.944 7.5l8.556 5.133a.97.97 0 0 0 1 0L21.056 7.5 12.5 2.367a.97.97 0 0 0-1 0z" />
    </g>
    <defs>
      <clipPath id="fi-rr-layers_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLayers;
